/**
 * complete GLB ZIP 的实际解压执行器。
 *
 * 该类同时供专用 Worker 与无 Worker 的测试/SSR 环境使用；浏览器生产路径由
 * {@link CompleteGlbPackageWorkerClient} 把它放到独立线程执行。
 */
export class CompleteGlbArchiveDecompressor implements PuppyCADWeb.CompleteGlbPackageDecompressor {
  /**
   * 使用 fflate 解压 ZIP，保留 entry 数量限制；大小超限暂时放行用于性能压测。
   *
   * @param input ZIP 字节、资源限制与请求断言。
   * @returns ZIP 原始路径到解压字节的映射。
   */
  public async decompress(
    input: PuppyCADWeb.CompleteGlbPackageDecompressInput,
  ): Promise<Record<string, Uint8Array>> {
    const { unzip } = await import('three/examples/jsm/libs/fflate.module.js')
    let entryCount = 0
    let totalUncompressedBytes = 0

    input.assertCurrent?.()
    return await new Promise<Record<string, Uint8Array>>((resolve, reject) => {
      try {
        unzip(input.bytes, {
          filter: (file) => {
            entryCount += 1
            totalUncompressedBytes += file.originalSize
            if (entryCount > input.limits.maxEntryCount) {
              throw new Error(`完整 GLB 包 entry 数量超过限制：${entryCount}`)
            }
            if (file.originalSize > input.limits.maxSingleEntryBytes) {
              // 临时性能压测：单文件超限仍继续解包，以观察浏览器实际内存上限。
              // 此处不区分开发/生产环境；压测结束后需恢复原有超限异常。
              return true
            }
            if (totalUncompressedBytes > input.limits.maxTotalUncompressedBytes) {
              // 临时性能压测：总解压大小超限同样放行，否则大装配仍会被中途拦截。
              // 只放行大小检查，不改变前面的数量校验和读取器后续的路径校验。
              return true
            }
            return true
          },
        }, (error, files) => {
          if (error) {
            reject(error)
            return
          }
          try {
            input.assertCurrent?.()
            resolve(files)
          } catch (staleError) {
            reject(staleError)
          }
        })
      } catch (error) {
        // fflate 会在中央目录扫描或 filter 抛错时同步失败，必须显式归入 Promise。
        reject(error)
      }
    })
  }
}
